import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AuditRepository = {
  getRevisions: (appEntryId) => {
    return axios.get(
      `${SETTINGS.INTERNAL_API_URL}audit/appEntries/${appEntryId}`
    );
  },

  compareRevisions: (appEntryId, firstRevisionId, secondRevisionId) => {
    return axios.get(
      `${SETTINGS.INTERNAL_API_URL}audit/appEntries/compareRevisions/${appEntryId}`,
      {
        params: {
          firstRevisionNumber: firstRevisionId,
          secondRevisionNumber: secondRevisionId,
        },
      }
    );
  },
};
